// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ExclamationCircleTwoToneSvg from "@fishx/icons-svg/es/asn/ExclamationCircleTwoTone";
import FishxIcon from '../components/FishxIcon';

var ExclamationCircleTwoTone = function ExclamationCircleTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ExclamationCircleTwoToneSvg
  }));
};

ExclamationCircleTwoTone.displayName = 'ExclamationCircleTwoTone';
export default React.forwardRef(ExclamationCircleTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ExclamationCircleTwoTone.js
// module id = 2629
// module chunks = 0